import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Modal,
  Form,
} from 'react-bootstrap';
import { Icon } from '@iconify/react';
import DataTable from "react-data-table-component";
import { Link } from 'react-router-dom';
import { getAIGeneratedStories, destroyAITale, updateTaleStatus } from '../../api/taleService';

export default function AIGeneratedTales() {
  const [searchText, setSearchText] = useState('');
  const [tales, setTales] = useState([]);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [taleToDelete, setTaleToDelete] = useState(null);
  const [error, setError] = useState(null);

  const handleClose = () => setShow(false);

  useEffect(() => {
    fetchTales();
  }, []);

  const fetchTales = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getAIGeneratedStories();
      if (response.data) {
        setTales(response.data);
      }
    } catch (error) {
      setError("Error fetching tales");
      console.error("Error fetching tales:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleToggleStatus = async (id, currentStatus) => {
    try {
      setError(null);
      const newStatus = currentStatus === "Active" ? "Inactive" : "Active";
      const response = await updateTaleStatus({taleId: id, status: newStatus});
      
      if (response) {
        setTales((prevTales) =>
          prevTales.map((tale) =>
            tale._id === id ? { ...tale, status: newStatus } : tale
          )
        );
      }
    } catch (error) {
      setError("Failed to update status");
      console.error("Error updating tale status:", error);
    }
  };

  const handleDeleteTale = async () => {
    if (!taleToDelete) return;

    try {
      setError(null);
      const response = await destroyAITale({taleId: taleToDelete});
      
      if (response) {
        setTales((prevTales) => prevTales.filter((tale) => tale._id !== taleToDelete));
        handleClose();
        setTaleToDelete(null);
      }
    } catch (error) {
      setError("Failed to delete tale");
      console.error("Error deleting tale:", error);
    }
  };

  const handleShowDeleteModal = (id) => {
    setTaleToDelete(id);
    setShow(true);
  };

  const columns = [
    {
      name: 'ID',
      width: '160px',
      selector: row => row._id,
      sortable: true,
      cell: (row) => row._id     
    },
    {
      name: 'Title',
      width: '190px',
      selector: row => row.title,
      sortable: true,
      cell: (row) => row.title
    },
    {
      name: 'Username',
      width: '180px',
      selector: row => row.userId.username ? row.userId.username : "N/A",
      sortable: true,
      cell: (row) => row.userId.username ? row.userId.username : "N/A"
    },
    // {
    //   name: 'AI Involvement Level',
    //   width: '210px',
    //   selector: row => row.AIInvolvementLevel,
    //   sortable: true,
    //   cell: (row) => row.AIInvolvementLevel
    // },
    {
      name: 'Date Created',
      width: '180px',
      selector: row => new Date(row.createdAt).toLocaleDateString(),
      sortable: true,
      cell: (row) => new Date(row.createdAt).toLocaleDateString(),
    },
    {
      name: 'Status',
      width: '150px',
      selector: row => row.Status,
      sortable: true,
      cell: (row) => (
        <Form.Check
          type="switch"
          id={`status-switch-${row.id}`}
          checked={row.status === 'Active'}
          onChange={() => handleToggleStatus(row._id, row.status)}
          className="status-switch"
        />
      )
    },
    {
      name: "Actions",
      width: "150px",
      cell: (row) => (
        <>
          <Link className="btnview" to={`/admin/tale-detail/${row._id}`}>
            <Icon icon="tabler:eye"></Icon>
          </Link>
          <Link className="btndelete" onClick={() => handleShowDeleteModal(row._id)}>
            <Icon icon="tabler:trash"></Icon>
          </Link>
        </>
      ),
    },
  ];

  const filteredData = tales.filter((tale) => {
    const title = tale.title || "";
    const username = (tale.userId && tale.userId.username) || "";
    const id = tale._id || "";
  
    return (
      title.toLowerCase().includes(searchText.toLowerCase()) ||
      username.toLowerCase().includes(searchText.toLowerCase()) ||
      id.toLowerCase().includes(searchText.toLowerCase())
    );
  });

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Header className="py-4">
              <h5>Tales</h5>
            </Card.Header>
            <Card.Body>
              <div className="text-end mb-3">
                <input
                  type="text"
                  placeholder="Search..."
                  className="searchfield"
                  value={searchText}
                  onChange={e => setSearchText(e.target.value)}
                />
              </div>
              {error && <div className="alert alert-danger">{error}</div>}
              <DataTable
                columns={columns}
                data={filteredData}
                pagination
                responsive
                progressPending={loading}
                className="custom-table"
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Modal className="modal_Delete" show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o"></Icon>
            <h3>Are You Sure ?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <Button onClick={handleClose} className="btn btn-primary-outline px-4 me-3">
            Cancel
          </Button>
          <Button className="btn btn-primary px-4 min_width110" onClick={handleDeleteTale}>
            Ok
          </Button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
